module.exports = "/images/city1.jpg?49bdec02fb8de546d5c9a7ab13ee5649";